<template>
  <div>
    <div v-if="bubbleMessages.length == 0" class="primary-color pl-1">{{ $t('No reply') }}</div>
    <div>
      <ul style="margin: 0; padding: 0">
        <li
          style="list-style-type: none"
          v-for="(item, index) in bubbleMessages"
          :key="'intent_item_' + index"
        >
          <template>
            <move-vertical
              :index="index"
              :max="bubbleMessages.length"
              @onMove="onMove(index, $event)"
              style="
                width: 20px;
                min-width: 20px;
                display: inline-block;
                float: left;
                margin-right: 10px;
              "
            >
              <a
                href="javascript:void(0);"
                v-if="
                  bubbleMessages &&
                    bubbleMessages.length > 0 &&
                    (item.type != 'flex' || isZwizAdmin)
                "
                @click="onDelete(index)"
                style="float: left; margin-left: 5px"
              >
                <i class="fas fa-trash"></i> </a
              >&nbsp;
            </move-vertical>
            <template v-if="item.type == 'text'">
              <template v-if="item.text == '{viewsummary}'">
                <view-cart-summary-viewer></view-cart-summary-viewer>
                <div class="clearfix"></div>
              </template>
              <template v-else>
                <div
                  class="message"
                  style="
                    float: left;
                    position: relative;
                    border-radius: 12px;
                    max-width: 240px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    cursor: pointer;
                  "
                >
                  <div style="font-size: 12px; color: black">
                    <template>
                      <div style="padding: 8px 6px 2px; background-color: #f1f0f0">
                        <div
                          class="form-control"
                          :class="{
                            'has-error': errors.has(
                              'answer_' + (indexAlternative - 1) + '_text_' + index
                            )
                          }"
                        >
                          <autoresize-textarea
                            maxlength="2000"
                            :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                            class
                            :placeholder="$t('Chatbot answers')"
                            v-model.trim="item.text"
                            name="answer"
                            data-vv-as="Answer"
                            :data-vv-name="'answer_' + (indexAlternative - 1) + '_text_' + index"
                            v-validate
                            style="resize: none; display: inherit; margin-bottom: 5px"
                          ></autoresize-textarea>
                          <v-layout>
                            <v-flex class="error--text">
                              {{
                                errors.first('answer_' + (indexAlternative - 1) + '_text_' + index)
                              }}
                            </v-flex>
                            <v-flex shrink class="text-xs-right caption grey--text">
                              {{ item.text.length }}/2000
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="clearfix"></div>
                </div>

                <intent-prefill
                  @addIntentPrefill="addIntentPrefill(indexAlternative - 1, index, $event)"
                ></intent-prefill>
              </template>
            </template>
            <template v-if="item.type == 'button'">
              <div
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  max-width: 240px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                "
              >
                <div style="font-size: 12px; color: black">
                  <template>
                    <div
                      style="
                        padding: 8px 6px 2px;
                        background-color: #f1f0f0;
                        border-top-left-radius: 10px;
                        border-top-right-radius: 10px;
                      "
                    >
                      <div
                        class="form-control"
                        :class="{
                          'has-error': errors.has(
                            'answer_' + (indexAlternative - 1) + '_text_' + index
                          )
                        }"
                      >
                        <autoresize-textarea
                          maxlength="640"
                          :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                          class
                          :placeholder="$t('Chatbot answers')"
                          v-model="item.text"
                          name="answer"
                          data-vv-as="Answer"
                          :data-vv-name="'answer_' + (indexAlternative - 1) + '_text_' + index"
                          v-validate
                          style="resize: none; display: inherit; margin-bottom: 5px"
                        ></autoresize-textarea>

                        <v-layout>
                          <v-flex class="error--text">
                            {{
                              errors.first('answer_' + (indexAlternative - 1) + '_text_' + index)
                            }}
                          </v-flex>
                          <v-flex shrink class="text-xs-right caption grey--text">
                            {{ item.text.length }}/640
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="clearfix"></div>
                <div
                  style="
                    float: left;
                    width: 100%;
                    border: 1px solid #eee;
                    border-bottom-left-radius: 12px;
                    border-bottom-right-radius: 12px;
                  "
                >
                  <ul class="message-group message-group-flush" style="margin-bottom: 0px">
                    <template v-if="item.buttons && item.buttons.length > 0">
                      <template v-for="(button, bindex) in item.buttons">
                        <li
                          v-if="button"
                          class="message-group-item text-xs-center"
                          style="
                            position: relative;
                            border-left: none;
                            border-right: none;
                            border-bottom: none;
                            border-radius: 0px;
                            padding: 5px 10px;
                          "
                          :style="{ 'border-top': bindex != 0 ? '1px solid #eee' : 'none' }"
                          :key="bindex"
                        >
                          <add-generic-button
                            :isEdit="true"
                            :ref="'buttonGeneric_' + bindex"
                            :key="'group_button_' + bindex + '_' + editTimestamp"
                            v-model="item.buttons[bindex]"
                            @onSave="editButton(index, bindex, $event)"
                          >
                            <div
                              slot="body"
                              class="text-xs-center"
                              style="overflow: auto; position: relative; width: 100%"
                            >
                              <div style="color: #0084ff" :title="button.title">
                                {{ button.title | truncate(12) }}
                              </div>
                              <div class="clearfix"></div>

                              <div style="margin: 0; font-size: 10px; color: darkgrey">
                                <div v-if="button.type == 'web_url'" :title="button.url">
                                  {{ button.url | truncate(20) }}
                                </div>
                                <div v-else-if="button.type == 'postback'" :title="button.payload">
                                  {{ button.payload | truncate(20) }}
                                </div>
                                <div
                                  v-else-if="button.type == 'phone_number'"
                                  :title="button.payload"
                                >
                                  {{ button.payload | truncate(20) }}
                                </div>
                                <div v-else>&nbsp;</div>
                              </div>
                            </div>

                            <template slot="append">
                              <v-list-tile
                                :disabled="bindex <= 0"
                                @click="onMoveButton(bindex, 'up', item)"
                              >
                                <v-list-tile-title
                                  :style="bindex <= 0 ? `color: lightgrey` : ''"
                                  class="primary-color"
                                  >{{ $t('Move up') }}</v-list-tile-title
                                >
                              </v-list-tile>
                              <v-list-tile
                                :disabled="bindex >= item.buttons.length - 1"
                                @click="onMoveButton(bindex, 'down', item)"
                              >
                                <v-list-tile-title
                                  :style="
                                    bindex >= item.buttons.length - 1 ? `color: lightgrey` : ''
                                  "
                                  class="primary-color"
                                  >{{ $t('Move down') }}</v-list-tile-title
                                >
                              </v-list-tile>
                              <v-list-tile @click="deleteButton(index, bindex)">
                                <v-list-tile-title class="primary-color">{{
                                  $t('Delete')
                                }}</v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </add-generic-button>
                        </li>
                      </template>
                    </template>
                    <li
                      v-if="item.buttons && item.buttons.length < 3"
                      class="message-group-item"
                      style="
                        border-left: none;
                        border-right: none;
                        border-bottom: none;
                        border-radius: 0px;
                        text-align: center;
                        padding: 10px 0px;
                      "
                      :style="{
                        'border-top': item.buttons.length != 0 ? '1px solid #eee' : 'none'
                      }"
                    >
                      <add-generic-button
                        :key="'group_new_button_' + saveTimestamp"
                        v-model="newButton"
                        @onSave="addNewButton(index, $event)"
                      >
                        <template slot="body">
                          <span class="fas fa-plus"></span>
                          {{ $t('Add button') }}
                        </template>
                      </add-generic-button>
                    </li>
                  </ul>
                </div>
                <input
                  type="hidden"
                  v-validate="''"
                  :name="'answer_' + (indexAlternative - 1) + '_buttons_' + index"
                  v-model="item.buttons.length"
                  data-vv-as="Buttons"
                />
                <div
                  class="form-control"
                  :class="{
                    'has-error': errors.has(
                      'answer_' + (indexAlternative - 1) + '_buttons_' + index
                    )
                  }"
                >
                  <span
                    class="text-error"
                    v-show="errors.has('answer_' + (indexAlternative - 1) + '_buttons_' + index)"
                  >
                    {{ errors.first('answer_' + (indexAlternative - 1) + '_buttons_' + index) }}
                  </span>
                </div>
              </div>
              <intent-prefill
                @addIntentPrefill="addIntentPrefill(indexAlternative - 1, index, $event)"
              ></intent-prefill>
            </template>
            <template v-else-if="item.type == 'image'">
              <div
                :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                "
              >
                <uploadfile
                  ref="answer"
                  v-model="item.image_url"
                  :height="181"
                  data-vv-as="Image"
                  :data-vv-name="'answer_' + (indexAlternative - 1) + '_image_' + index"
                  v-validate
                ></uploadfile>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-else-if="item.type == 'video'">
              <div
                :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                class="message"
                style="
                  min-height: 150px;
                  border: 1px solid #eee;
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                "
              >
                <template v-if="item.picture">
                  <v-img :src="item.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
                </template>
                <template v-else>
                  <v-responsive :aspect-ratio="16 / 9">
                    <div style="background: #eee; height: 100%"></div>
                  </v-responsive>
                </template>

                <v-layout
                  fill-height
                  absolute
                  class="text-xs-center"
                  style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                >
                  <div style="margin: auto; width: 100%" :title="item.source" :alt="item.source">
                    <v-btn fab small depressed color="white">
                      <v-icon large>play_circle_filled</v-icon>
                    </v-btn>
                  </div>
                </v-layout>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-else-if="item.type == 'generic'">
              <intent-generic-manage
                v-model="item.data"
                :ratio="item.ratio"
                @changeRatio="changeRatio(index, $event)"
                @deleteMessage="onDelete(index)"
              ></intent-generic-manage>
            </template>

            <template v-else-if="item.type == 'payment'">
              <div
                style="
                  padding: 1em;
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 240px;
                  min-height: 100px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  background-color: #eeeeee;
                "
              >
                <v-layout style="margin-bottom: 0px; word-break: break-all" row>
                  <vue-simple-svg
                    :filepath="'/static/img/assets/get_started/payment.svg'"
                    width="40px"
                    height="40px"
                    class="img"
                    style="
                      border-right: 2px solid #c5c5c5;
                      padding-right: 10px;
                      padding-top: 1em;
                      padding-bottom: 1em;
                      vertical-align: middle;
                    "
                  />
                  <v-flex style="padding-left: 1em">
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Detail') }}:</strong>
                      <br />
                      {{ item.data.detail }}
                    </div>
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Amount') }}:</strong>
                      <br />
                      {{ item.data.amount }}
                    </div>
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Delivery Method') }}:</strong>
                      <br />
                      {{ item.data.delivery.name }}
                    </div>
                    <div style="margin-bottom: 10px; white-space: break-spaces">
                      <strong>{{ $t('Response Message') }}:</strong>
                      <br />
                      {{ item.data.response }}
                    </div>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-btn
                  @click="paymentForm(item, index)"
                  fab
                  outline
                  color="primary"
                  class="extra-small"
                >
                  <i class="fa fa-pencil-alt middle"></i>
                </v-btn>
              </div>
              <!-- <intent-generic-manage v-model="item.data" @deleteMessage="onDelete(index)"></intent-generic-manage> -->
            </template>

            <template
              v-else-if="['removeandaddtocart', 'addtocart', 'removetocart'].includes(item.type)"
            >
              <span>
                <view-cart-summary-viewer2 :items="item.data"></view-cart-summary-viewer2>
              </span>
              <span style="inline-block">
                <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        @click="editRemoveAndAdd(item, index)"
                        fab
                        outline
                        color="primary"
                        class="extra-small"
                      >
                        <i class="fa fa-pencil-alt middle"></i>
                      </v-btn>
                    </template>
                    <span>{{ $t('edit') }}</span>
                  </v-tooltip>
                </div>
              </span>
            </template>

            <template v-else-if="item.type == 'welcome_message'">
              <message-viewer v-model="welcomeMessage.messages"></message-viewer>
              <!-- <intent-getstarted v-if="welcomeMessage" v-model="welcomeMessage"></intent-getstarted> -->
            </template>
            <template v-else-if="item.type == 'flex'">
              <intent-line-flex
                v-model="item.contents"
                @deleteMessage="onDelete(index)"
              ></intent-line-flex>
            </template>
            <template v-else-if="item.type == 'imagemap'">
              <intent-line-image-map
                v-model="bubbleMessages[index]"
                @deleteMessage="onDelete(index)"
              ></intent-line-image-map>
            </template>
            <template v-else-if="item.type == 'sticker'">
              <div
                :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  border: 1px solid #eee;
                  width: 100%;
                  max-width: 180px;
                "
              >
                <v-img
                  aspect-ratio="1"
                  :src="`/static/img/assets/stickers/${item.packageid}/${item.stickerid}.png`"
                  :lazy-src="`/static/img/assets/stickers/${item.packageid}/${item.stickerid}.png`"
                  style="width: 100%"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                <div
                  style="background: #4bd64b; padding: 10px; line-height: 20px"
                  small
                  disabled
                  class="white--text"
                >
                  {{ $t('This item will be shown only on Line Chatbot') }}
                </div>
              </div>
            </template>
            <div class="clearfix"></div>
            <div class="form-control has-error" style="margin-left: 30px">
              <span
                class="text-error"
                v-show="errors.has('answer_' + (indexAlternative - 1) + '_image_' + index)"
                >{{ errors.first('answer_' + (indexAlternative - 1) + '_image_' + index) }}</span
              >
            </div>
            <div style="margin-bottom: 10px"></div>
          </template>
        </li>
      </ul>
    </div>

    <v-layout class="mb-3" :class="{ 'red--text': bubbleCount >= addLimit }">
      <v-flex class="text-xs-right caption">{{ bubbleCount }} / {{ addLimit }}</v-flex>
    </v-layout>

    <template v-if="selectedBot.pagetype != 'enterprise'">
      <router-link
        :to="'/' + $i18n.locale() + '/upgrade'"
        v-if="$store.getters.getPackage != 'premium'"
        class="caption primary--text"
        v-show="bubbleCount == 5"
      >
        <v-icon small color="primary">lock</v-icon>
        {{ $t('For facebook, If you want to increase 5 more items, please upgrade to premium') }}
      </router-link>
    </template>

    <div class="mt-2 caption warning--text" v-if="bubbleCount > 5">
      <v-icon small color="warning">warning</v-icon>
      {{ $t('Warning: only 5 items will be shown on Line Chatbot') }}
    </div>

    <div style="overflow-x: auto; margin-top: 15px" class="pl-3">
      <label for class="caption">{{ $t('Add more item') }}</label>
      <ul class="customize-message-tool">
        <li
          v-ripple
          @click="addIntentItem('text')"
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-speech-bubble.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Message') }}
        </li>
        <li
          v-ripple
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          @click="addIntentItem('button')"
          :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-button.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Button') }}
        </li>
        <li
          v-ripple
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          @click="addIntentItem('image')"
          :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-image.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Image') }}
        </li>
        <li
          v-ripple
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          @click="addIntentItem('generic')"
          :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Menu list') }}
        </li>
        <li
          v-ripple
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          @click="addIntentItem('video')"
          :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-video.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Video') }}
        </li>
        <li
          v-ripple
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          @click="addIntentItem('welcome_message')"
          v-if="!isWelcome"
          :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-greeting.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Welcome') }}
        </li>

        <!-- <li
          v-ripple
          v-tooltip.top="{
            content: $t('GB Prime Payment function can be used only one alone.'),
            visible: inactiveAloneIntent,
          }"
          @click="paymentForm"
          :class="{ inactive: inactiveAloneIntent }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-payment.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('GB Prime Payment') }}
        </li>
        <li
          v-ripple
          v-tooltip.top="{
            content: $t('Add/Remove to cart function can be used only one alone.'),
            visible: inactiveAloneIntent,
          }"
          style="backround-color: grey"
          @click="cartaddremove"
          :class="{ inactive: inactiveAloneIntent }"
          v-if="!['{default_comment_to_inbox}'].includes(intentname)"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-cart.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Add/Remove to cart') }}
        </li> -->
        <li
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          v-ripple
          @click="addIntentItem('line_flex')"
          :class="{
            inactive:
              bubbleCount >= addLimit ||
              $store.getters.getPackage != 'premium' ||
              hasAloneIntent
          }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Line Flex') }}
          <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
            <v-premium-lock :inline="true"></v-premium-lock>
          </div>
        </li>
        <li
          v-if="
            ['102074341651763', '109547317606650', '394274810994296'].includes(selectedBot.pageid)
          "
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          v-ripple
          @click="addIntentItem('line_imagemap')"
          :class="{
            inactive:
              bubbleCount >= addLimit || $store.getters.getPackage != 'premium' || hasAloneIntent
          }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-imagemap.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Line Image Map') }}
          <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
            <v-premium-lock :inline="true"></v-premium-lock>
          </div>
        </li>
        <li
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          v-ripple
          @click="addIntentItem('line_sticker')"
          :class="{
            inactive:
              bubbleCount >= addLimit || $store.getters.getPackage != 'premium' || hasAloneIntent
          }"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-line-sticker.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Line Sticker') }}
          <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
            <v-premium-lock :inline="true"></v-premium-lock>
          </div>
        </li>
      </ul>
    </div>

    <input
      type="hidden"
      name="bubbleLimit"
      :data-vv-as="$t('Chatbot answers') + ' ' + indexAlternative"
      :value="bubbleCount"
      v-validate="'max_value:' + addLimit"
    />

    <v-dialog v-model="showLineFlex" width="1000">
      <v-card>
        <v-layout>
          <v-flex>
            <div class="primary--text headline pa-2">Line Flex Message</div>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab small @click="cancelAddFlexMessage">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-card-text v-if="flexMessage">
          <intent-line-flex-message v-model="flexMessage.contents"></intent-line-flex-message>
        </v-card-text>

        <v-card-text class="text-xs-center">
          <v-btn outline color="grey" @click="cancelAddFlexMessage">{{ $t('Cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="saveAddFlexMessage">{{ $t('Save') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLineImageMap" width="1000">
      <v-card>
        <v-layout>
          <v-flex>
            <div class="primary--text headline pa-2">Line Image Map</div>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab small @click="cancelAddImageMap">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-card-text v-if="showLineImageMap">
          <intent-line-image-map-message v-model="imageMap"></intent-line-image-map-message>
        </v-card-text>

        <v-card-text class="text-xs-center">
          <v-btn outline color="grey" @click="cancelAddImageMap">{{ $t('Cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="saveAddImageMap">{{ $t('Save') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <modal-video v-model="showVideo" @onAddVideo="addVideo"></modal-video>
    <intent-gb-prime
      @addIntentItem="addIntentItem"
      @updatePaymentItem="updatePaymentItem($event)"
    ></intent-gb-prime>
    <v-dialog scrollable v-model="showCartaddremove" max-width="800">
      <IntentCartAddRemove
        :data="showCartaddremoveTemp"
        v-if="showCartaddremove"
        @addIntentItem="addIntentItem"
        @updateRemoveAndAdd="updateRemoveAndAdd($event)"
        @close="closecartaddremove"
      ></IntentCartAddRemove>
    </v-dialog>

    <sticker-list v-model="showLineSticker" @sendSticker="addSticker"></sticker-list>
  </div>
</template>

<script>
import IntentGroupItem from './IntentGroupItem.js'

export default {
  mixins: [IntentGroupItem]
}
</script>

<style lang="scss">
.customize-message-tool .disabled {
  color: #d4d4d4 !important;
  background-color: #efefef !important;
}
.customize-message-tool .disabled .img {
  fill: #d4d4d4 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentGroupItem.vue